export enum Brands {
  IHG = '6c',
  HI = 'hi',
  HIEX = 'ex',
  STAYBRIDGE = 'sb',
  HUALUXE = 'ul',
  INTERCONTINENTAL = 'ic',
  CROWNEPLAZA = 'cp',
  CANDLEWOOD = 'cw',
  INDIGO = 'in',
  EVENHOTELS = 'vn',
  HOLIDAYINN_CLUB_VACATIONS = 'cv',
  HOLIDAYINN_RESORTS = 'rs',
  KIMPTON = 'ki',
  PAL = 'ma',
  SP = 'sp',
  SPCT = 'ct',
  SPND = 'nd',
  AVID = 'va',
  VOCO = 'vx',
  REGENT = 're'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/enums/brands.enum.ts